import { get, post, remove } from '@apps/firsthomecoach/src/api/utils';

export const getStatusDataContent = async () => get('/status-data-content');

const sendStatusDataContent = async params => post(`/status-data-content`, params);

const removeStatusDataContent = async ({ queryParams }) => remove(`/status-data-content?${queryParams}`);

export const statusDataContent = { sendStatusDataContent, getStatusDataContent, removeStatusDataContent };
